import * as React from 'react';
import React__default, { useMemo, useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var BackgroundImage = function BackgroundImage(_a) {
  var appUrl = _a.appUrl,
    imageUrl = _a.imageUrl;
  var _b = React.useState(false),
    imageError = _b[0],
    setImageError = _b[1];
  var handleError = function handleError() {
    return setImageError(true);
  };
  return React.createElement(React.Fragment, null, !imageError && React.createElement("img", {
    onError: handleError,
    src: "".concat(appUrl).concat(imageUrl),
    elementtiming: "banners"
  }));
};
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z$e = ".mdmBannerWrapper {\n  max-width: 260px;\n  max-height: 115px;\n  height: 115px;\n  width: 260px;\n  border-radius: 4px;\n  background: rgb(227, 227, 227);\n  cursor: pointer;\n  position: relative;\n}\n.mdmBannerWrapper img {\n  height: 115px;\n  width: 260px;\n  border-radius: 4px;\n  z-index: 1;\n  position: absolute;\n}\n.mdmBannerWrapper .oddsView.asRow {\n  justify-content: center !important;\n}";
styleInject(css_248z$e);
var BannerWrapper = function BannerWrapper(_a) {
  var children = _a.children,
    onClick = _a.onClick;
  return React__default.createElement("div", {
    className: "mdmBannerWrapper",
    onClick: onClick
  }, children);
};
function hasOverflow(field, maxCharacters) {
  return field.length > maxCharacters;
}
function truncateWithEllipsis(field, maxCharacters) {
  var ellipsis = "...";
  if (typeof field !== 'string') {
    return field;
  }
  if (hasOverflow(field, maxCharacters)) {
    return field.substring(0, maxCharacters - 2) + ellipsis;
  } else {
    return field;
  }
}
var css_248z$d = ".eventSelectionContainer {\n  height: 100%;\n  width: 100%;\n  border-radius: 4px;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  cursor: default;\n  position: absolute;\n  cursor: pointer;\n}\n\n.bannerHeaderGroup {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 15px;\n  padding: 0 10px 0 10px;\n  position: absolute;\n  top: 3px;\n  pointer-events: none;\n}\n.bannerHeaderGroup .flexButton {\n  height: 16px;\n  padding: 0 2px;\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--bannerText);\n  text-align: center;\n  font-size: 11px;\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  color: var(--bannerText);\n  cursor: pointer;\n}\n.bannerHeaderGroup .eventText {\n  font-size: 11px;\n  color: var(--bannerText);\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n}\n\n.bannerContentGroup {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  position: absolute;\n  top: 20%;\n  pointer-events: none;\n}\n.bannerContentGroup .titleText {\n  font-size: 18px;\n  font-family: var(--font-family-primary);\n  font-weight: 600;\n  color: var(--bannerText);\n  max-width: 90%;\n  text-align: center;\n  line-height: 18px;\n}\n.bannerContentGroup .subtitleText {\n  color: var(--bannerText);\n  font-family: var(--font-family-primary);\n  font-size: 11px;\n  font-weight: 400;\n  max-lines: 2;\n  margin-top: 2px;\n}\n\n.mdmSelectionButtonGroup {\n  display: flex;\n  width: 90%;\n  justify-content: space-evenly;\n  align-items: center;\n  position: absolute;\n  bottom: 8px;\n}\n.mdmSelectionButtonGroup button {\n  min-height: unset;\n  font-size: 12px;\n  padding-top: 4px;\n  height: 24px;\n  width: 115px;\n  border-radius: 4px;\n}\n.mdmSelectionButtonGroup .selectionButton {\n  height: 30px;\n  width: 115px;\n  border-radius: 4px;\n  background: var(--secondary);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--primaryStroke);\n  color: var(--foreground);\n}\n.mdmSelectionButtonGroup .selectionButton.selected {\n  border-left: 4px solid var(--selected);\n  background: var(--secondary);\n}\n.mdmSelectionButtonGroup .selectionButton:hover {\n  background: var(--primaryStroke);\n  color: var(--bannerText);\n}\n.mdmSelectionButtonGroup .selectionButton:hover .buttonMoneyLabel {\n  color: var(--bannerText);\n}\n.mdmSelectionButtonGroup .selectionButton .buttonPlayerLabel {\n  font-size: 12px;\n  font-weight: 400;\n  margin: 5px 0 -2px 0;\n}\n\n.buttonLabelGroup {\n  display: flex;\n  align-items: baseline;\n  width: 50%;\n  font-weight: 500;\n  margin: -4px 0 4px 0;\n}\n.buttonLabelGroup.single {\n  justify-content: center;\n}\n.buttonLabelGroup.double {\n  justify-content: space-between;\n}\n.buttonLabelGroup .buttonSpreadLabel {\n  font-size: 12px;\n  font-weight: 400;\n}\n.buttonLabelGroup .buttonMoneyLabel {\n  font-size: 12px;\n  color: var(--primaryButton);\n  font-weight: 600;\n}";
styleInject(css_248z$d);
function isSelection1(selectionData) {
  return selectionData.selectionId != undefined;
}
var Title = function Title(_a) {
  var _b = _a.bannerSubtext3,
    bannerSubtext3 = _b === void 0 ? null : _b,
    bannerTitle = _a.bannerTitle,
    dateString = _a.dateString;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "titleText"
  }, truncateWithEllipsis(bannerTitle, 76)), bannerSubtext3 ? React.createElement("div", {
    className: "subtitleText"
  }, truncateWithEllipsis("".concat(dateString, " | ").concat(bannerSubtext3), 50), " ") : React.createElement("div", {
    className: "subtitleText"
  }, dateString));
};
var SelectionHeader = function SelectionHeader(_a) {
  var bannerSubtext1 = _a.bannerSubtext1,
    bannerSubtext2 = _a.bannerSubtext2;
  return React.createElement("div", {
    className: "bannerHeaderGroup"
  }, React.createElement("div", {
    className: "eventText"
  }, truncateWithEllipsis(bannerSubtext1, 29)), bannerSubtext2 && React.createElement("div", {
    className: "flexButton"
  }, truncateWithEllipsis(bannerSubtext2, 10)));
};
var SelectionButton = function SelectionButton(_a) {
  var handleSelect = _a.handleSelect,
    index = _a.index,
    _b = _a.line,
    line = _b === void 0 ? null : _b,
    _c = _a.price,
    price = _c === void 0 ? null : _c,
    selected = _a.selected,
    selectionDisplayName = _a.selectionDisplayName;
  return React.createElement("div", {
    className: selected[index] ? "selectionButton selected" : "selectionButton",
    onClick: function onClick() {
      return handleSelect(index);
    }
  }, React.createElement("div", {
    className: "buttonPlayerLabel"
  }, truncateWithEllipsis(selectionDisplayName, 20)), React.createElement("div", {
    className: "buttonLabelGroup ".concat(line ? "double" : "single")
  }, line && React.createElement("div", {
    className: "buttonSpreadLabel"
  }, line < 0 ? line : "+" + line), price && React.createElement("div", {
    className: "buttonMoneyLabel"
  }, price < 0 ? price : "+" + price)));
};
var SelectionOptions = function SelectionOptions(_a) {
  var userThemePreference = _a.userThemePreference,
    bannerDetails = _a.bannerDetails,
    onSelect = _a.onSelect;
  var _b = React.useState([]),
    selected = _b[0],
    setSelected = _b[1];
  var _c = React.useState([]),
    selections = _c[0],
    setSelections = _c[1];
  React.useEffect(function () {
    var initialSelected = selections.map(function () {
      return false;
    });
    setSelected(initialSelected);
  }, [selections]);
  React.useEffect(function () {
    if (isSelection1(bannerDetails)) {
      var selections_1 = [{
        selectionId: bannerDetails.selectionId,
        selectionDisplayName: bannerDetails.selectionDisplayName,
        price: 100,
        line: 5.5
      }];
      setSelections(selections_1);
    } else {
      var selections_2 = [{
        selectionId: bannerDetails.selectionId1,
        selectionDisplayName: bannerDetails.selectionDisplayName1,
        price: 100
      }, {
        selectionId: bannerDetails.selectionId2,
        selectionDisplayName: bannerDetails.selectionDisplayName2,
        price: 100
      }];
      setSelections(selections_2);
    }
  }, [bannerDetails]);
  var handleSelect = function handleSelect(index) {
    var selectionId = selections[index].selectionId;
    var eventId = bannerDetails.eventId,
      marketId = bannerDetails.marketId;
    var updatedSelectedState = __spreadArray([], selected, true);
    updatedSelectedState[index] = !updatedSelectedState[index];
    onSelect({
      selectionId: selectionId,
      eventId: eventId,
      marketId: marketId
    });
    setSelected(updatedSelectedState);
  };
  return React.createElement("div", {
    className: "mdmSelectionButtonGroup ".concat(userThemePreference === "dark" ? "darkMode" : "")
  }, selections.map(function (selection, index) {
    return React.createElement(SelectionButton, _assign({
      key: selection.selectionDisplayName,
      index: index,
      selected: selected,
      handleSelect: handleSelect
    }, selection));
  }));
};
var ChildrenSelectionOption = function ChildrenSelectionOption(_a) {
  var bannerDetails = _a.bannerDetails,
    children = _a.children;
  var _b = React.useState([]),
    selections = _b[0],
    setSelections = _b[1];
  React.useEffect(function () {
    var _a;
    var selections = (_a = bannerDetails === null || bannerDetails === void 0 ? void 0 : bannerDetails.event) === null || _a === void 0 ? void 0 : _a.markets.flatMap(function (market) {
      return market.selections.flatMap(function (selection) {
        return {
          selectionId: selection.id,
          selectionDisplayName: getSelectionDisplayName(bannerDetails, selection),
          price: selection.price.a,
          line: market.line,
          eventId: bannerDetails.eventId,
          marketId: bannerDetails.marketId,
          event: bannerDetails.event,
          market: market,
          selection: selection,
          marketType: market.type,
          spOffered: market.spOffered
        };
      });
    });
    setSelections(selections);
  }, [bannerDetails]);
  var getSelectionDisplayName = function getSelectionDisplayName(bannerData, selectionData) {
    if (bannerData.selectionDisplayName) {
      return bannerData.selectionDisplayName;
    }
    if (bannerData.selectionId1 === selectionData.id) {
      return bannerData.selectionDisplayName1;
    }
    if (bannerData.selectionId2 === selectionData.id) {
      return bannerData.selectionDisplayName2;
    }
    return selectionData.name;
  };
  return React.createElement("div", {
    className: "mdmSelectionButtonGroup"
  }, selections.map(function (selection) {
    return children(selection);
  }));
};
var Selection = function Selection(_a) {
  var _b;
  var appUrl = _a.appUrl,
    bannerDetails = _a.bannerDetails,
    onSelect = _a.onSelect,
    _c = _a.userThemePreference,
    userThemePreference = _c === void 0 ? "light" : _c,
    children = _a.children,
    handleBannerClick = _a.handleBannerClick;
  var startTime = ((_b = bannerDetails === null || bannerDetails === void 0 ? void 0 : bannerDetails.event) === null || _b === void 0 ? void 0 : _b.startTime) || "";
  var dateString = new Date(startTime).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  });
  var checkBannerClickEvent = function checkBannerClickEvent(e) {
    if (e.target.id === "wrapper") {
      handleBannerClick();
    }
  };
  return React.createElement(BannerWrapper, {
    onClick: checkBannerClickEvent
  }, React.createElement(BackgroundImage, {
    appUrl: appUrl,
    imageUrl: bannerDetails.imageUrl
  }), React.createElement("div", {
    className: "eventSelectionContainer",
    id: "wrapper"
  }, React.createElement(SelectionHeader, {
    bannerSubtext1: bannerDetails.bannerSubtext1,
    bannerSubtext2: bannerDetails.bannerSubtext2
  }), React.createElement("div", {
    className: "bannerContentGroup"
  }, React.createElement(Title, {
    dateString: dateString,
    bannerSubtext3: bannerDetails.bannerSubtext3,
    bannerTitle: bannerDetails.bannerTitle
  })), !children ? React.createElement(SelectionOptions, {
    bannerDetails: bannerDetails,
    userThemePreference: userThemePreference,
    onSelect: onSelect
  }) : React.createElement(ChildrenSelectionOption, {
    bannerDetails: bannerDetails,
    children: children
  })));
};
var Static = function Static(_a) {
  var bannerDetails = _a.bannerDetails,
    appUrl = _a.appUrl,
    handleBannerClick = _a.handleBannerClick;
  var imageUrl = bannerDetails.imageUrl;
  return React.createElement(BannerWrapper, {
    onClick: handleBannerClick
  }, React.createElement(BackgroundImage, {
    appUrl: appUrl,
    imageUrl: imageUrl
  }));
};
var StaticPromotion = function StaticPromotion(_a) {
  var bannerDetails = _a.bannerDetails,
    appUrl = _a.appUrl,
    handleBannerClick = _a.handleBannerClick;
  var imageUrl = bannerDetails.imageUrl;
  return React.createElement(BannerWrapper, {
    onClick: handleBannerClick
  }, React.createElement(BackgroundImage, {
    appUrl: appUrl,
    imageUrl: imageUrl
  }));
};
var css_248z$c = ".LoadingSpinnerCircle {\n  display: flex;\n  justify-content: center;\n}\n\n.LoadingSpinnerCircle::after {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--disabled);\n  border-top-color: var(--attentionBackground);\n  /* border-bottom-color: #60d460;  -- optional */\n  border-radius: 50%;\n  /* animation: spin 0.6s 0.1s linear infinite both; -- optional */\n  animation: spin 0.8s 0.1s ease-in-out infinite both;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes bounce {\n  to {\n    opacity: 1;\n    transform: scale(1.75);\n  }\n}";
styleInject(css_248z$c);

// Generated with util/create-component.js
var LoadingSpinnerCircle = function LoadingSpinnerCircle() {
  return React__default.createElement("div", {
    "data-testid": "LoadingSpinnerCircle",
    className: "LoadingSpinnerCircle"
  });
};
var POSITION = {
  0: "left",
  1: "right"
};
var OptInCta = function OptInCta(_a) {
  var loading = _a.loading,
    isOptedIn = _a.isOptedIn,
    isMultiplier = _a.isMultiplier,
    bannerDetails = _a.bannerDetails,
    onClick = _a.onClick;
  var ctaDisplayName = bannerDetails.ctaDisplayName,
    ctaPosition = bannerDetails.ctaPosition;
  var position = POSITION[ctaPosition];
  var buttonContent = useMemo(function () {
    var optInLabel = isMultiplier ? "Activate" : "Opt In";
    var ctaLabel = isOptedIn ? ctaDisplayName || "Bet Now" : optInLabel;
    return loading ? React__default.createElement(LoadingSpinnerCircle, null) : ctaLabel;
  }, [loading]);
  var className = "OptInPromotion__button ".concat(position, " ").concat(loading ? "loading" : "");
  var handleClick = useCallback(function (event) {
    return !loading && onClick(event);
  }, [loading]);
  return React__default.createElement("button", {
    onClick: handleClick,
    className: className
  }, buttonContent);
};
var css_248z$b = ".OptInPromotion__buttonWrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  padding: 8px;\n  z-index: 2;\n  position: relative;\n  flex-direction: column;\n}\n.OptInPromotion__button {\n  background: #128152;\n  outline: none;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 30px;\n  width: 64px;\n  height: 24px;\n  transition: 0.15s;\n  cursor: pointer;\n}\n.OptInPromotion__button.loading {\n  transition: 0.15s;\n}\n.OptInPromotion__button.left {\n  margin: auto 0 0 0;\n}\n.OptInPromotion__button.right {\n  margin: auto 0 0 auto;\n}\n.OptInPromotion__button-spinner {\n  display: \"inline-block\";\n}\n.OptInPromotion__optInMessage {\n  width: 50px;\n  height: 14px;\n  background: white;\n  border-radius: 2px;\n  display: flex;\n}\n.OptInPromotion__optInMessage div {\n  margin: auto;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 400;\n  font-family: var(--font-family-secondary);\n  color: black;\n}";
styleInject(css_248z$b);
var STATUS = {
  UNAVAILABLE: "unavailable",
  AVAILABLE: "available",
  OPTED_IN: "opted_in"
};
var OptInPromotion = function OptInPromotion(_a) {
  var bannerDetails = _a.bannerDetails,
    appUrl = _a.appUrl,
    loading = _a.loading,
    handleOptInClick = _a.handleOptInClick,
    handleBannerClick = _a.handleBannerClick;
  var imageUrl = bannerDetails.imageUrl,
    opt_in_status = bannerDetails.opt_in_status,
    campaignRewardType = bannerDetails.campaignRewardType;
  var currentStatus = useMemo(function () {
    var _a = opt_in_status || {},
      available = _a.opt_in_available,
      optedIn = _a.customer_opted_in;
    return available ? optedIn ? STATUS.OPTED_IN : STATUS.AVAILABLE : STATUS.UNAVAILABLE;
  }, [opt_in_status]);
  var isOptedIn = useMemo(function () {
    return currentStatus === STATUS.OPTED_IN;
  }, [currentStatus]);
  var isMultiplier = useMemo(function () {
    return campaignRewardType === null || campaignRewardType === void 0 ? void 0 : campaignRewardType.includes("-multiplier");
  }, [campaignRewardType]);
  var checkBannerClickEvent = function checkBannerClickEvent(e) {
    if (e.target.id === "wrapper") {
      handleBannerClick();
    }
  };
  return React__default.createElement(BannerWrapper, null, React__default.createElement(BackgroundImage, {
    appUrl: appUrl,
    imageUrl: imageUrl
  }), React__default.createElement("div", {
    className: "OptInPromotion__buttonWrapper",
    onClick: checkBannerClickEvent,
    id: "wrapper"
  }, isOptedIn && React__default.createElement("div", {
    className: "OptInPromotion__optInMessage"
  }, React__default.createElement("div", null, isMultiplier ? "ACTIVATED" : "OPTED IN")), React__default.createElement(OptInCta, {
    loading: loading,
    isOptedIn: isOptedIn,
    isMultiplier: isMultiplier,
    bannerDetails: bannerDetails,
    onClick: handleOptInClick
  })));
};
var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  EventBanner: Selection,
  Static: Static,
  StaticPromotion: StaticPromotion,
  OptInPromotion: OptInPromotion
});
var BANNER_LAYOUT_ID;
(function (BANNER_LAYOUT_ID) {
  BANNER_LAYOUT_ID["SELECTION_1"] = "selection_1";
  BANNER_LAYOUT_ID["SELECTION_2"] = "selection_2";
  BANNER_LAYOUT_ID["OPT_IN"] = "optin";
  BANNER_LAYOUT_ID["STATIC_PROMOTION"] = "static_promotion";
  BANNER_LAYOUT_ID["GENERIC"] = "static";
})(BANNER_LAYOUT_ID || (BANNER_LAYOUT_ID = {}));
var renderPromotionBanner = function renderPromotionBanner(props) {
  return React.createElement(StaticPromotion, _assign({}, props));
};
var renderOptInBanner = function renderOptInBanner(props) {
  return React.createElement(OptInPromotion, _assign({}, props));
};
var renderGenericBanner = function renderGenericBanner(props) {
  return React.createElement(Static, _assign({}, props));
};
var renderEventBanner = function renderEventBanner(props) {
  return React.createElement(Selection, _assign({}, props));
};
var Banner = function Banner(_a) {
  var bannerDetails = _a.bannerDetails,
    appUrl = _a.appUrl,
    _b = _a.onSelect,
    onSelect = _b === void 0 ? null : _b,
    _c = _a.children,
    children = _c === void 0 ? null : _c,
    _d = _a.loading,
    loading = _d === void 0 ? false : _d,
    _e = _a.handleOptInClick,
    handleOptInClick = _e === void 0 ? null : _e,
    _f = _a.handleBannerClick,
    handleBannerClick = _f === void 0 ? function () {} : _f;
  var bannerLayoutId = bannerDetails.bannerLayoutId;
  switch (bannerLayoutId) {
    case BANNER_LAYOUT_ID.GENERIC:
      return renderGenericBanner({
        bannerDetails: bannerDetails,
        appUrl: appUrl,
        handleBannerClick: handleBannerClick
      });
    case BANNER_LAYOUT_ID.OPT_IN:
      return renderOptInBanner({
        bannerDetails: bannerDetails,
        appUrl: appUrl,
        loading: loading,
        handleOptInClick: handleOptInClick,
        handleBannerClick: handleBannerClick
      });
    case BANNER_LAYOUT_ID.STATIC_PROMOTION:
      return renderPromotionBanner({
        bannerDetails: bannerDetails,
        appUrl: appUrl,
        handleBannerClick: handleBannerClick
      });
    case BANNER_LAYOUT_ID.SELECTION_1:
      return renderEventBanner({
        bannerDetails: bannerDetails,
        appUrl: appUrl,
        onSelect: onSelect,
        children: children,
        handleBannerClick: handleBannerClick
      });
    case BANNER_LAYOUT_ID.SELECTION_2:
      return renderEventBanner({
        bannerDetails: bannerDetails,
        appUrl: appUrl,
        onSelect: onSelect,
        children: children,
        handleBannerClick: handleBannerClick
      });
    default:
      return null;
  }
};
var css_248z$a = ".EmptySpaceNotification {\n  color: var(--foreground);\n  background: var(--background);\n  margin: 0;\n  padding: 60px 50px 0 50px;\n  width: 100%;\n  height: 60vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.EmptySpaceNotification .EmptySpaceNotification_headerRow {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.EmptySpaceNotification .EmptySpaceNotification_headerRow.error {\n  color: var(--error);\n}\n.EmptySpaceNotification .EmptySpaceNotification_headerRow.info {\n  color: var(--infoText);\n}\n.EmptySpaceNotification svg {\n  transform: scale(1.4);\n}\n.EmptySpaceNotification h2 {\n  margin-left: 20px;\n  padding-top: 0.05em;\n}\n.EmptySpaceNotification p {\n  text-align: center;\n  font-weight: 400;\n}";
styleInject(css_248z$a);
var EmptySpaceNotification = function EmptySpaceNotification(_a) {
  var type = _a.type,
    headerText = _a.headerText,
    bodyText = _a.bodyText,
    children = _a.children;
  return React__default.createElement("div", {
    "data-testid": "EmptySpaceNotification",
    className: "EmptySpaceNotification"
  }, React__default.createElement("div", {
    className: "EmptySpaceNotification_headerRow ".concat(type)
  }, children, React__default.createElement("h2", null, headerText)), React__default.createElement("p", null, bodyText));
};
var css_248z$9 = ".ErrorBangCircle path {\n  fill: var(--error);\n}";
styleInject(css_248z$9);
var ErrorBangCircle = function ErrorBangCircle() {
  return React__default.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 28 28",
    xmlSpace: "preserve",
    className: "ErrorBangCircle"
  }, React__default.createElement("path", {
    className: "st0",
    d: "M0,14c0,7.7,6.3,14,14,14s14-6.3,14-14c0-7.7-6.3-14-14-14S0,6.3,0,14z M26.7,14c0,7-5.7,12.7-12.7,12.7C7,26.7,1.3,21,1.3,14C1.3,7,7,1.3,14,1.3C21,1.3,26.7,7,26.7,14z M14.7,14c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7V8.7C13.3,8.3,13.6,8,14,8s0.7,0.3,0.7,0.7V14z M14.7,18.7v-1.3h-1.3v1.3H14.7z"
  }));
};
var ErrorBangCircle$1 = React__default.memo(ErrorBangCircle);
var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */

function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}
function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);
  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }
        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */

function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }
  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
    id = _createObserver.id,
    observer = _createObserver.observer,
    elements = _createObserver.elements; // Register the callback listener for this element

  var callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    threshold = _ref.threshold,
    delay = _ref.delay,
    trackVisibility = _ref.trackVisibility,
    rootMargin = _ref.rootMargin,
    root = _ref.root,
    triggerOnce = _ref.triggerOnce,
    skip = _ref.skip,
    initialInView = _ref.initialInView,
    fallbackInView = _ref.fallbackInView;
  var unobserve = React.useRef();
  var _React$useState = React.useState({
      inView: !!initialInView
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var setRef = React.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer

    if (skip) return;
    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });
        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  },
  // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [
  // If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  useEffect(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}
var lower = function lower(string) {
  return string.toLowerCase();
};
var replaceEmptyStrings = function replaceEmptyStrings(string) {
  return string.replace(/ /g, "-");
};
var cleanDisplayName = function cleanDisplayName(string) {
  return replaceEmptyStrings(lower(string));
};
function createQA_String(index, bannerLayoutId, displayName) {
  var cleanedDisplayName = cleanDisplayName(displayName);
  return "mdmBanner_".concat(index, "_").concat(bannerLayoutId, "__").concat(cleanedDisplayName);
}
function createListElementDataQA(child, index) {
  var _a, _b, _c, _d, _e;
  if (!((_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.bannerDetails) === null || _b === void 0 ? void 0 : _b.bannerLayoutId) || !((_d = (_c = child === null || child === void 0 ? void 0 : child.props) === null || _c === void 0 ? void 0 : _c.bannerDetails) === null || _d === void 0 ? void 0 : _d.collectionDisplayName)) {
    // fallback for non banner element
    return "h_scrolling_list_item_".concat(index);
  }
  var _f = (_e = child === null || child === void 0 ? void 0 : child.props) === null || _e === void 0 ? void 0 : _e.bannerDetails,
    bannerLayoutId = _f.bannerLayoutId,
    collectionDisplayName = _f.collectionDisplayName;
  return createQA_String(index, bannerLayoutId, collectionDisplayName);
}
var css_248z$8 = ".scrollingListArrow {\n  z-index: 5;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  opacity: 1;\n  transition: opacity ease-in-out 0.5s;\n}\n@media only screen and (max-width: 768px) {\n  .scrollingListArrow {\n    display: none;\n  }\n}\n.scrollingListArrow svg {\n  height: 2.4rem;\n  width: 2.4rem;\n  fill: none;\n}\n.scrollingListArrow svg circle {\n  fill: var(--background);\n  stroke: var(--primary);\n  stroke-width: 0.5;\n}\n.scrollingListArrow svg path {\n  fill: var(--primary);\n}\n.scrollingListArrow .scrollingListArrowButton {\n  z-index: 5;\n  height: 100%;\n  margin: 0 1.2rem;\n}\n.scrollingListArrow .scrollingListArrowOverlay {\n  z-index: -1;\n  position: absolute;\n  top: 0;\n  background: rgb(196, 196, 196);\n  opacity: 0.5;\n  height: 100%;\n  width: 100%;\n}\n.scrollingListArrow.scrollingListLeftArrow {\n  left: 0;\n}\n.scrollingListArrow.scrollingListLeftArrow .scrollingListArrowOverlay {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.scrollingListArrow.scrollingListRightArrow {\n  right: 0;\n}\n.scrollingListArrow.scrollingListRightArrow .scrollingListArrowOverlay {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.scrollingListArrow.hidden {\n  opacity: 0;\n  cursor: none;\n  pointer-events: none;\n}\n\n.scrollingListItems {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n}\n@media only screen and (max-width: 768px) {\n  .scrollingListItems {\n    overflow: scroll;\n  }\n}\n.scrollingListItems > div {\n  margin-right: 1.2rem;\n}\n.scrollingListItems > div:first-child {\n  margin-left: 1.2rem;\n}\n\n.scrollingListContainer {\n  display: flex;\n  position: relative;\n  overflow: hidden;\n}\n.scrollingListContainer .Skeleton__Container {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n}\n.scrollingListContainer .Skeleton__Banner {\n  min-width: 320px;\n  max-height: 150px;\n  height: 150px;\n  width: 320px;\n  border-radius: 4px;\n  background: rgb(227, 227, 227);\n  cursor: pointer;\n  position: relative;\n}\n.scrollingListContainer .Skeleton__Banner:first-child {\n  margin-left: 0;\n}";
styleInject(css_248z$8);
var css_248z$7 = ".bannerListContainer {\n  display: flex;\n}\n.bannerListContainer > div {\n  margin-right: 8px;\n}\n.bannerListContainer > div:first-child {\n  margin-left: 12px;\n}\n\n.banners_container {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  max-height: 115px;\n}";
styleInject(css_248z$7);

// Generated with util/create-component.js
var LeftSliderArrow = function LeftSliderArrow(_a) {
  var hideArrow = _a.hideArrow,
    onClick = _a.onClick,
    _b = _a.qaTag,
    qaTag = _b === void 0 ? "left-slider-arrow" : _b;
  return React__default.createElement("div", {
    className: "scrollingListArrow scrollingListLeftArrow".concat(hideArrow ? " hidden" : ""),
    onClick: onClick,
    "data-qa": qaTag
  }, React__default.createElement("div", {
    className: "scrollingListArrowOverlay"
  }), React__default.createElement("svg", {
    className: "scrollingListArrowButton",
    viewBox: "0 0 24 24"
  }, React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9.75"
  }), React__default.createElement("path", {
    d: "M13.59 18L15 16.59L10.42 12L15 7.41L13.59 6L7.59005 12L13.59 18Z"
  })));
};
var RightSliderArrow = function RightSliderArrow(_a) {
  var hideArrow = _a.hideArrow,
    onClick = _a.onClick,
    _b = _a.qaTag,
    qaTag = _b === void 0 ? "right-slider-arrow" : _b;
  return React__default.createElement("div", {
    className: "scrollingListArrow scrollingListRightArrow".concat(hideArrow ? " hidden" : ""),
    onClick: onClick,
    "data-qa": qaTag
  }, React__default.createElement("div", {
    className: "scrollingListArrowOverlay"
  }), React__default.createElement("svg", {
    className: "scrollingListArrowButton",
    viewBox: "0 0 24 24"
  }, React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9.75"
  }), React__default.createElement("path", {
    d: "M10.41 6L9 7.41L13.58 12L9 16.59L10.41 18L16.41 12L10.41 6Z"
  })));
};
var ListItem = function ListItem(_a) {
  var child = _a.child,
    index = _a.index,
    trackingDetails = _a.trackingDetails,
    itemRef = _a.itemRef,
    onVisibilityChange = _a.onVisibilityChange,
    bannerInView = _a.bannerInView;
  var _b = useInView({
      threshold: 1
    }),
    ref = _b[0],
    inView = _b[1];
  useEffect(function () {
    onVisibilityChange(index, inView);
    inView && bannerInView(trackingDetails);
  }, [index, inView]);
  var qaTag = createListElementDataQA(child, index);
  return React__default.createElement("div", {
    ref: itemRef
  }, React__default.createElement("div", {
    ref: ref,
    "data-qa": qaTag
  }, child));
};
var ARROW_DIRECTION;
(function (ARROW_DIRECTION) {
  ARROW_DIRECTION["LEFT"] = "left";
  ARROW_DIRECTION["RIGHT"] = "right";
})(ARROW_DIRECTION || (ARROW_DIRECTION = {}));
var SliderArrow = function SliderArrow(_a) {
  var _b = _a.direction,
    direction = _b === void 0 ? ARROW_DIRECTION.LEFT : _b,
    _c = _a.hideArrow,
    hideArrow = _c === void 0 ? false : _c,
    onClick = _a.onClick;
  if (direction === ARROW_DIRECTION.LEFT) {
    return React__default.createElement(LeftSliderArrow, {
      hideArrow: hideArrow,
      onClick: onClick
    });
  }
  return React__default.createElement(RightSliderArrow, {
    hideArrow: hideArrow,
    onClick: onClick
  });
};
var HorizontalScrollingList = function HorizontalScrollingList(_a) {
  var children = _a.children,
    _b = _a.scrollIntoViewInline,
    scrollIntoViewInline = _b === void 0 ? "start" : _b,
    _c = _a.bannerInView,
    bannerInView = _c === void 0 ? function () {
      return null;
    } : _c,
    isLoading = _a.isLoading;
  var numberOfItems = React__default.Children.count(children);
  var _d = useState(0),
    currentIndex = _d[0],
    setCurrentIndex = _d[1];
  var _e = useState(false),
    showLeftArrow = _e[0],
    setShowLeftArrow = _e[1];
  var _f = useState(false),
    showRightArrow = _f[0],
    setShowRightArrow = _f[1];
  var itemRefs = {};
  var setItemRef = function setItemRef(index) {
    return function (element) {
      return itemRefs[index] = element;
    };
  };
  var onItemVisibilityChange = function onItemVisibilityChange(index, inView) {
    if (index === 0) {
      setShowLeftArrow(!inView);
    }
    if (index === numberOfItems - 1) {
      setShowRightArrow(!inView);
    }
  };
  var scrollToItem = function scrollToItem(itemIndex) {
    if (itemIndex > -1) {
      var scrollToRef = itemRefs[itemIndex];
      // Ensure first slide is always in view
      var inline = itemIndex === 0 ? "center" : scrollIntoViewInline;
      scrollToRef.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: inline
      });
      setCurrentIndex(itemIndex);
    }
  };
  var scrollLeft = function scrollLeft() {
    if (currentIndex > 0) {
      scrollToItem(currentIndex - 1);
    }
  };
  var scrollRight = function scrollRight() {
    if (currentIndex < numberOfItems - 1) {
      scrollToItem(currentIndex + 1);
    }
  };
  return React__default.createElement("div", {
    className: "scrollingListContainer"
  }, React__default.createElement(SliderArrow, {
    onClick: scrollLeft,
    direction: ARROW_DIRECTION.LEFT,
    hideArrow: !showLeftArrow
  }), React__default.createElement("div", {
    className: "scrollingListItems"
  }, !isLoading && children && React__default.Children.map(children, function (child, i) {
    return React__default.createElement(ListItem, {
      child: child,
      index: i,
      trackingDetails: React__default.isValidElement(child) ? child.props.trackingDetails : {},
      itemRef: setItemRef(i),
      key: i,
      onVisibilityChange: onItemVisibilityChange,
      bannerInView: bannerInView
    });
  }), isLoading && React__default.createElement(SkeletonBanners, null)), React__default.createElement(SliderArrow, {
    onClick: function onClick() {
      return scrollRight();
    },
    direction: ARROW_DIRECTION.RIGHT,
    hideArrow: !showRightArrow
  }));
};
var SkeletonBanners = function SkeletonBanners() {
  var numOfSkeletons = 6;
  var skeletons = [];
  for (var i = 0; i < numOfSkeletons; i++) {
    skeletons.push(true);
  }
  var SkeletonBanner = function SkeletonBanner() {
    return React__default.createElement("div", {
      className: "Skeleton__Banner"
    });
  };
  return React__default.createElement("div", {
    className: "scrollingListItems"
  }, skeletons.map(function (_skeleton, index) {
    return React__default.createElement(SkeletonBanner, {
      key: index
    });
  }));
};
var css_248z$6 = ".CheckCircle--path1 {\n  fill: #FFFFFF;\n  stroke: #000000;\n}\n\n.CheckCircle--path2 {\n  fill: #FFFFFF;\n  filter: url(#Adobe_OpacityMaskFilter);\n}\n\n.CheckCircle--path3 {\n  mask: url(#path-1-inside-1_2_);\n}";
styleInject(css_248z$6);
var CheckCircle = function CheckCircle() {
  return React__default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20"
  }, React__default.createElement("g", null, React__default.createElement("path", {
    className: "CheckCircle--path1",
    d: "M10,0.5c5.2,0,9.5,4.3,9.5,9.5s-4.3,9.5-9.5,9.5S0.5,15.2,0.5,10S4.8,0.5,10,0.5z"
  }), React__default.createElement("path", {
    d: "M13.6,5.9l-5.1,5.4L6.4,8.9L5,10.3l2.2,2.4l1.3,1.4l1.4-1.4L15,7.3L13.6,5.9z"
  }), React__default.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: "2.2",
    y: "3",
    width: "15.5",
    height: "14",
    id: "path-1-inside-1_2_"
  }, React__default.createElement("path", {
    className: "CheckCircle--path2",
    d: "M13.6,5.9l-5.1,5.4L6.4,8.9L5,10.3l2.2,2.4l1.3,1.4l1.4-1.4L15,7.3L13.6,5.9z"
  })), React__default.createElement("path", {
    className: "CheckCircle--path3",
    d: "M13.6,5.9l1.4-1.4L13.6,3l-1.4,1.5L13.6,5.9z M8.5,11.3l-1.5,1.4l1.5,1.6l1.5-1.6L8.5,11.3z M6.4,8.9l1.5-1.4\n      L6.4,6L4.9,7.5L6.4,8.9z M5,10.3L3.6,8.9l-1.3,1.4l1.3,1.4L5,10.3z M7.2,12.7l1.5-1.4l0,0L7.2,12.7z M8.5,14.1l-1.5,1.4L8.5,17\n      l1.5-1.5L8.5,14.1z M9.9,12.7l1.4,1.4l0,0l0,0L9.9,12.7z M15,7.3l1.5,1.4l1.3-1.4l-1.3-1.4L15,7.3z M12.2,4.5L7.1,10l2.9,2.7\n      l5.1-5.4L12.2,4.5z M10,10L7.8,7.6l-2.9,2.7l2.2,2.4L10,10z M4.9,7.5L3.6,8.9l2.9,2.8l1.4-1.4L4.9,7.5z M3.5,11.7l2.2,2.4l2.9-2.7\n      L6.5,9L3.5,11.7z M5.8,14.1l1.3,1.4l2.9-2.7l-1.3-1.4L5.8,14.1z M10,15.5l1.4-1.4l-2.9-2.8l-1.4,1.4L10,15.5z M11.4,14.1l5.1-5.4\n      l-2.9-2.7l-5.1,5.4L11.4,14.1z M16.4,5.9l-1.4-1.4l-2.9,2.8l1.4,1.4L16.4,5.9z"
  })));
};
var css_248z$5 = ".BangCircle--circle {\n  fill: #FFFFFF;\n  stroke: #000000;\n}";
styleInject(css_248z$5);
var BangCircle = function BangCircle() {
  return React__default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20"
  }, React__default.createElement("g", null, React__default.createElement("circle", {
    className: "BangCircle--circle",
    cx: "10",
    cy: "10",
    r: "9.5"
  }), React__default.createElement("path", {
    d: "M9.2,11.8h1.7l0.3-7.3H8.8L9.2,11.8z M8.8,14.2c0,0.7,0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2\n      S8.8,13.5,8.8,14.2z"
  })));
};
var css_248z$4 = ".InfoBar {\n  width: 100%;\n  height: 52px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.InfoBar .InfoBar--link {\n  margin-right: 16px;\n  font-size: 1.6rem;\n  font-weight: 700;\n  text-decoration: underline;\n  cursor: pointer;\n  color: white;\n}\n.InfoBar.checking {\n  color: var(--foreground);\n  background: var(--activePill);\n}\n.InfoBar.error {\n  color: white;\n  background: var(--error);\n}\n.InfoBar.verified {\n  color: white;\n  background: var(--attentionBackground);\n}\n.InfoBar.custom {\n  color: var(--foreground);\n  background: var(--alert);\n}\n.InfoBar.custom .InfoBar--link {\n  color: var(--foreground);\n}\n.InfoBar .InfoBar--iconAndTitle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.InfoBar .InfoBar--iconAndTitle svg {\n  width: 20px;\n}\n.InfoBar .InfoBar--iconAndTitle svg,\n.InfoBar .InfoBar--iconAndTitle .LoadingSpinnerCircle {\n  margin-left: 16px;\n}\n.InfoBar .InfoBar--iconAndTitle span {\n  font-size: 1.6rem;\n  font-weight: 700;\n  margin-left: 16px;\n}";
styleInject(css_248z$4);

// Generated with util/create-component.js
var renderIconAndTitle = function renderIconAndTitle(type, customText) {
  switch (type) {
    case 'checking':
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(LoadingSpinnerCircle, null), React__default.createElement("span", null, "Checking Location, please wait..."));
    case 'verified':
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(CheckCircle, null), React__default.createElement("span", null, "Location Verified"));
    case 'error':
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(BangCircle, null), React__default.createElement("span", null, "Can not verify your location"));
    case 'custom':
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(BangCircle, null), React__default.createElement("span", null, customText));
  }
};
var renderLinkText = function renderLinkText(type) {
  switch (type) {
    case 'checking':
      return '';
    case 'verified':
      return '';
    case 'error':
      return 'View details';
    case 'custom':
      return 'View details';
    default:
      return '';
  }
};
var InfoBar = function InfoBar(_a) {
  var type = _a.type,
    customText = _a.customText,
    onClick = _a.onClick;
  return React__default.createElement("div", {
    "data-testid": "InfoBar",
    className: "InfoBar ".concat(type)
  }, React__default.createElement("div", {
    className: "InfoBar--iconAndTitle"
  }, renderIconAndTitle(type, customText)), React__default.createElement("a", {
    className: "InfoBar--link",
    onClick: onClick
  }, renderLinkText(type)));
};
var css_248z$3 = ".InfoCircle path {\n  fill: var(--infoText);\n}";
styleInject(css_248z$3);
var InfoCircle = function InfoCircle() {
  return React__default.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0",
    y: "0",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    className: "InfoCircle"
  }, React__default.createElement("path", {
    d: "M9.9,12.6h1.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4H7.7c-0.2,0-0.5-0.2-0.5-0.4s0.2-0.4,0.5-0.4\n      H9V8.1H7.7c-0.2,0-0.5-0.2-0.5-0.5c0-0.2,0.2-0.5,0.5-0.5h1.8c0.2,0,0.4,0.2,0.4,0.5V12.6L9.9,12.6z M9,18c-5,0-9-4-9-9s4-9,9-9\n      s9,4,9,9S14,18,9,18z M9,17.1c4.5,0,8.1-3.6,8.1-8.1S13.5,0.9,9,0.9S0.9,4.5,0.9,9S4.5,17.1,9,17.1z M8.6,4.5h0.9\n      c0.2,0,0.4,0.2,0.4,0.4v0.9c0,0.2-0.2,0.5-0.4,0.5H8.6c-0.2,0-0.4-0.2-0.4-0.5V4.9C8.1,4.7,8.3,4.5,8.6,4.5z"
  }));
};
var InfoCircle$1 = React__default.memo(InfoCircle);
var css_248z$2 = ".ListIcon .ListIcon--circle {\n  fill: var(--logo1);\n}\n.ListIcon .ListIcon--circle.inverted {\n  fill: var(--logo1);\n}\n.ListIcon .ListIcon--circleFill {\n  fill: var(--background);\n}\n.ListIcon .ListIcon--circleFill.inverted {\n  fill: var(--logo1);\n  transform: scale(1.05) translate(-0.5px, -0.5px);\n}\n.ListIcon .ListIcon--listElements {\n  fill: var(--logo1);\n}\n.ListIcon .ListIcon--listElements.inverted {\n  fill: var(--background);\n}";
styleInject(css_248z$2);
var ListIcon = function ListIcon(_a) {
  var inverted = _a.inverted;
  return React__default.createElement("svg", {
    viewBox: "0 0 24 24",
    className: "ListIcon"
  }, React__default.createElement("g", null, React__default.createElement("g", null, React__default.createElement("circle", {
    className: "ListIcon--circleFill ".concat(inverted ? 'inverted' : ''),
    cx: "12",
    cy: "12",
    r: "11"
  }), React__default.createElement("path", {
    className: "ListIcon--circle ".concat(inverted ? 'inverted' : ''),
    d: "M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12C24,5.4,18.6,0,12,0z M12,23\n          C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z"
  })), React__default.createElement("path", {
    className: "ListIcon--listElements ".concat(inverted ? 'inverted' : ''),
    d: "M7.2,9.6C7.7,9.6,8,9.2,8,8.8S7.7,7.9,7.2,7.9c-0.5,0-0.8,0.4-0.8,0.8S6.7,9.6,7.2,9.6z M9.8,9.4h7.3\n        c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H9.8c-0.3,0-0.6,0.3-0.6,0.6S9.5,9.4,9.8,9.4z M7.2,13C7.7,13,8,12.6,8,12.1\n        c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C6.4,12.6,6.7,13,7.2,13z M9.8,12.7h7.3c0.3,0,0.6-0.3,0.6-0.6\n        c0-0.3-0.3-0.6-0.6-0.6H9.8c-0.3,0-0.6,0.3-0.6,0.6C9.3,12.5,9.5,12.7,9.8,12.7z M7.2,16.3c0.5,0,0.8-0.4,0.8-0.8\n        c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C6.4,15.9,6.7,16.3,7.2,16.3z M9.8,16.1h7.3c0.3,0,0.6-0.3,0.6-0.6\n        c0-0.3-0.3-0.6-0.6-0.6H9.8c-0.3,0-0.6,0.3-0.6,0.6C9.3,15.8,9.5,16.1,9.8,16.1z"
  })));
};
var ListIcon$1 = React__default.memo(ListIcon);
var X = function X(_a) {
  var fill = _a.fill;
  return React__default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12"
  }, React__default.createElement("path", {
    className: "x-path",
    fill: fill || 'black',
    d: "M6,5.2l5-5c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8l-5,5l5,5c0.2,0.2,0.2,0.6,0,0.8\n    c-0.2,0.2-0.6,0.2-0.8,0l-5-5l-5,5c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8l5-5l-5-5c-0.2-0.2-0.2-0.6,0-0.8\n    c0.2-0.2,0.6-0.2,0.8,0L6,5.2z"
  }));
};
var css_248z$1 = ".Background {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.45);\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ModalWrapper {\n  width: 330px;\n  min-height: 200px;\n  background: var(--bg-layer-one);\n  border-radius: 16px;\n}\n.ModalWrapper .ModalHeader:not(#customHeader) {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n}\n.ModalWrapper .ModalHeader:not(#customHeader) button {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n}\n.ModalWrapper .ModalHeader:not(#customHeader) button svg {\n  width: 12px;\n}\n.ModalWrapper .ModalHeader:not(#customHeader) button svg path {\n  fill: var(--foreground);\n}\n\n.ModalContent {\n  padding: 0 24px 24px 24px;\n}";
styleInject(css_248z$1);
var Modal = function Modal(_a) {
  var showModal = _a.showModal,
    setShowModal = _a.setShowModal,
    _b = _a.preventBackgroundClose,
    preventBackgroundClose = _b === void 0 ? false : _b,
    children = _a.children,
    rest = __rest(_a, ["showModal", "setShowModal", "preventBackgroundClose", "children"]);
  var customHeader = rest.customHeader,
    ariaLabel = rest.ariaLabel,
    ariaLabelledByOverride = rest.ariaLabelledByOverride;
  var closeModal = function closeModal(e) {
    if (preventBackgroundClose) return;
    if (e.currentTarget === e.target) {
      setShowModal(false);
    }
  };
  var ariaAttributes = {};
  if (customHeader && !ariaLabel && !ariaLabelledByOverride) {
    ariaAttributes["aria-labelledby"] = "customHeader";
  } else if (!customHeader && ariaLabel) {
    ariaAttributes["aria-label"] = ariaLabel;
  }
  if (!ariaLabel && ariaLabelledByOverride) {
    ariaAttributes["aria-labelledby"] = ariaLabelledByOverride;
  }
  return React__default.createElement(React__default.Fragment, null, showModal ? React__default.createElement("div", {
    className: "Background",
    onClick: closeModal
  }, React__default.createElement("div", _assign({
    role: "dialog",
    className: "ModalWrapper",
    "data-testid": "ModalWrapper"
  }, ariaAttributes), customHeader ? React__default.createElement("div", _assign({
    className: "ModalHeader"
  }, !ariaLabelledByOverride && {
    id: "customHeader"
  }), customHeader) : React__default.createElement("div", {
    className: "ModalHeader"
  }, React__default.createElement("button", {
    "data-testid": "CloseButton",
    "aria-label": "Close modal",
    onClick: function onClick() {
      return setShowModal(false);
    }
  }, React__default.createElement(X, {
    fill: "black"
  }))), React__default.createElement("div", {
    className: "ModalContent"
  }, children))) : null);
};
var css_248z = ".foo-bar {\n  color: var(--primary);\n}";
styleInject(css_248z);
var getModalRoot = function getModalRoot(root) {
  return document.getElementById(root);
};
var ModalPortal = function ModalPortal(_a) {
  var children = _a.children,
    modalRoot = _a.modalRoot,
    isOpen = _a.isOpen,
    setIsOpen = _a.setIsOpen,
    _b = _a.preventBackgroundClose,
    preventBackgroundClose = _b === void 0 ? false : _b,
    rest = __rest(_a, ["children", "modalRoot", "isOpen", "setIsOpen", "preventBackgroundClose"]);
  var handleEscape = useCallback(function (e) {
    if (e.keyCode === 27) setIsOpen(false);
  }, []);
  useEffect(function () {
    if (isOpen) document.addEventListener('keydown', handleEscape, false);
    return function () {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [handleEscape, isOpen]);
  return createPortal(isOpen ? React__default.createElement(Modal, _assign({
    showModal: isOpen,
    setShowModal: setIsOpen,
    preventBackgroundClose: preventBackgroundClose
  }, rest), children) : null, getModalRoot(modalRoot));
};
var OtherPageId;
(function (OtherPageId) {
  OtherPageId["HOMEPAGE"] = "homepage";
  OtherPageId["CASINO"] = "casino";
})(OtherPageId || (OtherPageId = {}));
var SportId;
(function (SportId) {
  SportId["AMERICANFOOTBALL"] = "americanfootball";
  SportId["ATHLETICS"] = "athletics";
  SportId["AUSTRALIANRULES"] = "australianrules";
  SportId["BADMINTON"] = "badminton";
  SportId["BASEBALL"] = "baseball";
  SportId["BASKETBALL"] = "basketball";
  SportId["BEACHSOCCER"] = "beachsoccer";
  SportId["BEACHVOLLEYBALL"] = "beachvolleyball";
  SportId["BOWLS"] = "bowls";
  SportId["BOXING"] = "boxing";
  SportId["CRICKET"] = "cricket";
  SportId["CYCLING"] = "cycling";
  SportId["DARTS"] = "darts";
  SportId["DIVING"] = "diving";
  SportId["ESPORTS"] = "esports";
  SportId["FIELDHOCKEY"] = "fieldhockey";
  SportId["FISHING"] = "fishing";
  SportId["FOOTBALL"] = "football";
  SportId["FUTSAL"] = "futsal";
  SportId["GAELICFOOTBALL"] = "gaelicfootball";
  SportId["GAELICHURLING"] = "gaelichurling";
  SportId["GOLF"] = "golf";
  SportId["GREYHOUNDRACING"] = "greyhoundracing";
  SportId["HANDBALL"] = "handball";
  SportId["HORSERACING"] = "horseracing";
  SportId["ICEHOCKEY"] = "icehockey";
  SportId["LACROSSE"] = "lacrosse";
  SportId["MOTORBIKES"] = "motorbikes";
  SportId["MOTORSPORT"] = "motorsport";
  SportId["NETBALL"] = "netball";
  SportId["OLYMPICS"] = "olympics";
  SportId["POKER"] = "poker";
  SportId["POLITICS"] = "politics";
  SportId["POOL"] = "pool";
  SportId["ROWING"] = "rowing";
  SportId["RUGBYLEAGUE"] = "rugbyleague";
  SportId["RUGBYUNION"] = "rugbyunion";
  SportId["SNOOKER"] = "snooker";
  SportId["SOFTBALL"] = "softball";
  SportId["SPECIALS"] = "specials";
  SportId["SQUASH"] = "squash";
  SportId["SUMO"] = "sumo";
  SportId["SWIMMING"] = "swimming";
  SportId["TABLETENNIS"] = "tabletennis";
  SportId["TENNIS"] = "tennis";
  SportId["UFCMMA"] = "ufcmma";
  SportId["VOLLEYBALL"] = "volleyball";
  SportId["WATERPOLO"] = "waterpolo";
  SportId["WINTERSPORTS"] = "wintersports";
})(SportId || (SportId = {}));
var VALID_SPORT_IDS = Object.values(SportId);
var VALID_SPORT_PATHS = VALID_SPORT_IDS.map(function (path) {
  return "/".concat(path);
});
var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get OtherPageId() {
    return OtherPageId;
  },
  get SportId() {
    return SportId;
  },
  VALID_SPORT_IDS: VALID_SPORT_IDS,
  VALID_SPORT_PATHS: VALID_SPORT_PATHS
});
function validateString(field) {
  if (typeof field !== "string") {
    return false;
  }
  return !!field && field.length > 0;
}
function isUUID(uuid) {
  return !!uuid.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$");
}
function isPath(path) {
  return !!path.match("^/([A-z0-9-_+]+/)*([A-z0-9-]+)$");
}
function isValidHomePath(field) {
  //Example: / leads home.
  return field === "/";
}
function isValidCasinoCategoryPagePath(field) {
  //Example: /casino/category/db3f563f-dd1c-4d43-8082-86c04b78d827
  if (!isPath(field)) {
    return false;
  }
  var uuid = parse(field).slice(-1)[0];
  return field.startsWith("/casino/category/") && isUUID(uuid);
}
function isValidCasinoThunderbitePath(field) {
  //Example: /casino/tb/wheel-of-fortune
  return field.startsWith("/casino/tb/") && isPath(field);
}
function isValidCasinoGamePath(field) {
  //Example: /casino/game/516
  var gameId = Number(field.split("/").pop());
  return field.startsWith("/casino/game/") && Number.isInteger(gameId);
}
function isValidCasinoPath(field) {
  //Example: /casino
  return field === "/casino";
}
function isValidSportsPagePath(path) {
  return VALID_SPORT_PATHS.includes(path);
}
function isValidPromoPath(field) {
  //Example: /promos or /promos/bet-it-all
  return field === "/promos" || field.startsWith("/promos/") && isPath(field);
}
function parse(path) {
  return path.split("/").filter(function (string) {
    return validateString(string);
  });
}
function isValidEventPagePath(path) {
  if (!isPath(path)) {
    return false;
  }
  var _a = parse(path),
    sport = _a[0],
    uuid = _a[1],
    event = _a[2];
  if (!sport || !uuid || !event) {
    return false;
  }
  var validSport = VALID_SPORT_IDS.includes(sport);
  var validUUID = isUUID(uuid);
  var validEvent = validateString(event);
  return validSport && validUUID && validEvent;
}
function isValidEventsAllPagePath(path) {
  //Example: /baseball/events/all
  if (!isPath(path)) {
    return false;
  }
  var _a = parse(path),
    sport = _a[0],
    events = _a[1],
    all = _a[2];
  if (!sport || !events || !all) {
    return false;
  }
  var validSport = VALID_SPORT_IDS.includes(sport);
  var validEventsSection = events === "events";
  var validAllSection = all === "all";
  return validAllSection && validEventsSection && validSport;
}
function isValidDeeplinkPath(path) {
  return path.includes('?dl=');
}
function isValid_MDM_V2_BannerPath(path) {
  return isValidHomePath(path) || isValidCasinoPath(path) || isValidCasinoCategoryPagePath(path) || isValidCasinoThunderbitePath(path) || isValidCasinoGamePath(path) || isValidPromoPath(path) || isValidSportsPagePath(path) || isValidEventPagePath(path) || isValidEventsAllPagePath(path) || isValidDeeplinkPath(path);
}
function handle_MDM_V1_landingPageUrl(path) {
  return "/promos".concat(path);
}
function handle_MDM_V1_ctaUrl(sportId) {
  return "/".concat(sportId);
}
function handle_LandingPageUrl(path) {
  if (!isValid_MDM_V2_BannerPath(path)) {
    return handle_MDM_V1_landingPageUrl(path);
  }
  return path;
}
function handle_ctaUrl(path) {
  if (!isValid_MDM_V2_BannerPath(path)) {
    return handle_MDM_V1_ctaUrl(path);
  }
  return path;
}
var tools = /*#__PURE__*/Object.freeze({
  __proto__: null,
  validateString: validateString,
  isUUID: isUUID,
  isPath: isPath,
  isValidHomePath: isValidHomePath,
  isValidCasinoCategoryPagePath: isValidCasinoCategoryPagePath,
  isValidCasinoThunderbitePath: isValidCasinoThunderbitePath,
  isValidCasinoGamePath: isValidCasinoGamePath,
  isValidCasinoPath: isValidCasinoPath,
  isValidSportsPagePath: isValidSportsPagePath,
  isValidPromoPath: isValidPromoPath,
  parse: parse,
  isValidEventPagePath: isValidEventPagePath,
  isValidEventsAllPagePath: isValidEventsAllPagePath,
  isValidDeeplinkPath: isValidDeeplinkPath,
  isValid_MDM_V2_BannerPath: isValid_MDM_V2_BannerPath,
  handle_LandingPageUrl: handle_LandingPageUrl,
  handle_ctaUrl: handle_ctaUrl
});
var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  types: types,
  tools: tools
});
export { Banner, index$1 as BannerLayouts, EmptySpaceNotification, ErrorBangCircle$1 as ErrorBangCircle, HorizontalScrollingList, InfoBar, InfoCircle$1 as InfoCircle, ListIcon$1 as ListIcon, LoadingSpinnerCircle, index as MDMPathToolKit, Modal, ModalPortal };